"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import Grid from "@mui/material/Grid" // Grid version 2
import PrimaryAndSecondaryButtonsContainer from "../shared/PrimaryAndSecondaryButtonsContainer"
import Reason from "./shared/Reason"
import Header from "../shared/Header"
import SectionContainer from "../shared/SectionContainer"
import {
  CREATED_ZESTLIFE_REASON_STAND_FOR_GROUPS,
  CREATED_ZESTLIFE_REASON_OPEN_DOORS,
  CREATED_ZESTLIFE_REASON_STRONGER_TOGETHER,
  PRIMARY_YELLOW_BUTTON_TYPE,
  SECONDARY_BUTTON_TYPE,
} from "../shared/constants"
import useRedirectToLeaderOnboarding from "../../../../hooks/useRedirectToLeaderOnboarding"

function WhyWeCreatedZestLife() {
  const [
    { isLoggedIn },
    { getRouteForLeaderOnboarding, getMonthlyListingsClickHandler },
  ] = useRedirectToLeaderOnboarding()
  const renderHeader = () => {
    return <Header text="We created ZestLife because" />
  }

  const renderButtons = () => {
    return (
      <PrimaryAndSecondaryButtonsContainer
        button1={{
          type: PRIMARY_YELLOW_BUTTON_TYPE,
          text: "Join community",
          href: getRouteForLeaderOnboarding(),
        }}
        button2={{
          type: SECONDARY_BUTTON_TYPE,
          text: "Get monthly listings",
          onClick: async () => {
            getMonthlyListingsClickHandler()
          },
        }}
      />
    )
  }

  const renderReasons = () => {
    return (
      <Grid
        container
        spacing={{ xs: 2 }}
        columns={{ xs: 9 }}
        direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "stretch",
          flexGrow: 1,
        }}
      >
        <Reason reasonType={CREATED_ZESTLIFE_REASON_STAND_FOR_GROUPS} />
        <Reason reasonType={CREATED_ZESTLIFE_REASON_OPEN_DOORS} />
        <Reason reasonType={CREATED_ZESTLIFE_REASON_STRONGER_TOGETHER} />
      </Grid>
    )
  }

  return (
    <SectionContainer color={"faded-blue"}>
      {renderHeader()}
      {renderReasons()}
      {renderButtons()}
    </SectionContainer>
  )
}
export default WhyWeCreatedZestLife
